/** Мок API: игрок. */
import type { FakeDb, FakeHandlers } from "./db";

export function playerHandlers(
  db: FakeDb,
): FakeHandlers<"playerState" | "setLocale" | "sendFeedback" | "setWriteAccess" | "adminTool"> {
  return {
    playerState: async () => db.fresh(),
    adminTool: async () => db.fresh(),
    setLocale: async (req) => ({ locale: req.locale }),
    sendFeedback: async () => ({}),
    setWriteAccess: async (req) => ({ allowsWriteToPm: req.allowed }),
  };
}
